import { observable, action } from "mobx";
import FormStore from "~/stores/FormStore";
import Address from "~/models/Address";
import Tour from "~/models/Tour";

class AddressStore {
  @observable selectedAddressResult = null;

  @observable addressResults = [];

  @observable formStore = null;

  constructor() {
    this.formStore = new FormStore();
  }

  /**
   * Bind tour in the context of a tour address.
   */
  @action
  bindTourToForm(tour) {
    if (tour instanceof Tour === false) {
      throw new Error("tour variable expected to be an instance of ~/models/Tour.js");
    }

    const { address, latitude, longitude } = tour;

    let lat = null;
    let lng = null;

    // bind the tour's lat/lng (if any).
    if (latitude && longitude) {
      // these props are likely to be string numbers.
      lat = parseFloat(latitude);
      lng = parseFloat(longitude);
    }

    // Set the inline property explicitly because it's a computed value and won't get spread.
    this.formStore = new FormStore({
      ...address,
      inline: address.inline,
      lat,
      lng,
    });
  }

  /**
   * @property {Address} address an instance of Address.js
   */
  @action
  bindAddressToForm(address) {
    if (address instanceof Address === false) {
      throw new Error("address variable expected to be an instance of ~/model/Address.js");
    }

    this.formStore = new FormStore({
      ...address,
      // inline must be set explicitly because it's computed and won't get spread.
      inline: address.inline,
    });
  }

  @action
  setAddressResults(addressResults) {
    this.addressResults = addressResults;
  }

  @action
  setSelectedAddressResult(selectedAddressResult) {
    this.selectedAddressResult = selectedAddressResult;
  }
}

export default AddressStore;
